"use strict";
/**
 * QVET Client Duplicate Detection Contracts
 *
 * Types for the duplicate client detection and audit system.
 * Returns groups of clients (2 or more) detected as potential duplicates
 * using scoring-based matching on phone, email, name, and pet data.
 *
 * @example GET /api/qvet/clients/duplicates?branch=URBAN&confidence=HIGH
 */
Object.defineProperty(exports, "__esModule", { value: true });
